import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ApmTranslatePipe } from '@mitsubishi/core';
import { ClassColorPipe, ColorAccentDirective, ListTileComponent, SectionTitleComponent } from '@mitsubishi/shared/ui';

import { ClassSelectionComponent } from './class-selection.component';

@NgModule({
  declarations: [ClassSelectionComponent],
  imports: [
    CommonModule,
    ClassColorPipe,
    ColorAccentDirective,
    ListTileComponent,
    SectionTitleComponent,
    ApmTranslatePipe,
  ],
  exports: [ClassSelectionComponent],
})
export class ClassSelectionModule {}
